import AbstractItem from "./AbstractItem";

export default abstract class AbstractOutputItem extends AbstractItem {
}
